<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zry
 * @LastEditTime: 2024-10-28 09:48:54
 * @Description: 维保计划新增/修改
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm-80 o-dialog--md-90 o-dialog--lg-120 o-dialog--xl-120"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      class="o-tips u-mg-b-10"
      style="margin-top: -10px;"
    >
      <div class="o-tips__title">
        {{ dlParams.id ? '说明：' : '说明：维保合同有效期内才可添加计划' }}
      </div>
      <ul
        v-if="dlParams.id"
        class="o-tips__body"
      >
        <li class="o-tips__item">
          1、计划维保内容如需更改请在维保项目管理更改客户的维保内容；
        </li>
        <li class="o-tips__item">
          2、生成报告后如需修改请用主账号开启重新修改功能。
        </li>
      </ul>
    </div>
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col c-form__part-title"
          :span="24"
        >
          维保计划
        </el-col>
        <el-col
          v-if="dlParams.id === undefined && $route.params.xmId === undefined"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="项目名称"
            prop="xmId"
          >
            <el-select
              v-model="fd.xmId"
              class="c-form__select"
              placeholder="请选择"
              clearable
              @change="handleXmChange"
            >
              <el-option
                v-for="(item,index) in xmList"
                :key="index"
                :label="item.xmmc"
                :value="item.xmId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-else
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="项目名称"
            prop="xmId"
          >
            <span>
              {{ fd.xmmc }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="合同有效期"
            prop="htyxq"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <span
              v-show="fd.xmId"
            >
              {{ htyxqQ | date('yyyy-MM-dd') }}
              至
              {{ htyxqZ | date('yyyy-MM-dd') }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="计划年份"
            prop="jhnf"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <el-select
              v-show="fd.xmId"
              v-model="fd.jhnf"
              class="c-form__select"
              placeholder="请选择"
              clearable
              @change="handleJhmc()"
            >
              <el-option
                v-for="(item,index) in jhnfList"
                :key="index"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维保周期"
            prop="jhlxDmList"
          >
            <el-checkbox-group
              v-model="fd.jhlxDmList"
              class="c-form__checkbox-group"
            >
              <el-checkbox
                v-for="item in jhlxList"
                :key="item.id"
                :label="item.id"
              >
                {{ item.text }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="计划名称"
            prop="selectedJhmcIds"
          >
            <el-checkbox-group
              v-model="selectedJhmcIds"
              class="c-form__checkbox-group"
              @change="handleJhmcChange"
            >
              <el-checkbox
                v-for="(item, index) in wbjhSaveV2DetailVOS"
                :key="index"
                :label="item.id"
              >
                {{ item.jhmc }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维保人员"
            prop="wbryDmList"
          >
            <select-xm-user
              v-model="fd.wbryDmList"
              role-code="WBRY"
              :show-dept="false"
              multiple
              collapse-tags
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="项目负责人"
            prop="xmfzrDm"
          >
            <select-xm-user
              v-model="fd.xmfzrDm"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="技术负责人"
            prop="jsfzrDm"
          >
            <select-xm-user
              v-model="fd.jsfzrDm"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="维保内容"
            prop="wbnrJhList"
          >
            <el-checkbox-group
              v-model="fd.wbnrJhList"
              class="c-form__checkbox-group"
            >
              <el-checkbox
                v-for="item in wbnrXmList"
                :key="item.wbnrId"
                :label="item.wbnrId"
              >
                {{ item.wbnrMc }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="任务描述"
            prop="rwms"
          >
            <el-input
              v-model="fd.rwms"
              class="c-form__input"
              type="textarea"
              rows="4"
              placeholder="请输入任务描述"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col
          v-if="editShow"
          class="c-form__col c-form__part-title"
          :span="24"
        >
          分配信息
        </el-col> -->
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbjhService } from './wbjh.service';
import { wbxmService } from '../wbxm/wbxm.service';

import SelectXmUser from '../../components/SelectXmUser/SelectXmUser.vue';

export default {
  name: 'WbjhSaveDialog',
  components: { SelectXmUser },
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      selectedJhmcIds: [], // 用于存储选中的计划名称ID
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      editShow: false, // 编辑模式显示
      paginationShow: false, // 分页显示
      xmList: [], // 项目列表
      wbjhSaveV2DetailVOS: [], // 维保计划明细
      wbryList: [], // 维保人员列表
      wbnrXmList: [], // 维保内容
      jhlxMc: '', // 计划类型名称
      jhnfList: [], // 计划年份列表
      jhmcList: [],
      htyxqQ: null, // 合同有效期起
      htyxqZ: null, // 合同有效期止

      /* 表单参数 Start */
      fd: {
        xmId: null, // 项目ID
        xmmc: null, // 项目名称
        jhlxDm: null, // 计划类型
        jhlxDmList: [], // 计划类型列表
        jhnf: null, // 计划年份
        selectedJhmcIds: [], // 选中的计划名称ID
        wbjhSaveV2DetailVOS: [], // 维保计划明细
        jhsjQ: null, // 计划开始时间
        jhsjZ: null, // 计划结束时间
        wbzq: null, // 维保周期
        wbryDmList: [], // 维保人员
        xmfzrDm: null, // 项目负责人
        jsfzrDm: null, // 技术负责人
        wbnrJhList: [], // 维保内容
        rwms: '对各系统进行定期维护保养，测试并出具维保报告。' // 任务描述
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        xmId: [
          this.$validUtils.required('项目名称')
        ], // 客户名称
        jhlxDmList: [
          this.$validUtils.required('计划类型')
        ], // 计划类型
        jhnf: [
          this.$validUtils.required('计划年份')
        ], // 计划年份
        selectedJhmcIds: [
          this.$validUtils.required('计划名称')
        ], // 计划名称
        wbryDmList: [
          this.$validUtils.required('维保人员')
        ], // 维保人员
        jsfzrDm: [
          this.$validUtils.required('技术负责人')
        ], // 技术负责人
        xmfzrDm: [
          this.$validUtils.required('项目负责人')
        ], // 项目负责人
        rwms: [
          this.$validUtils.required('任务描述'),
          this.$HMValidator.maxLength('任务描述', 3000)
        ], // 任务描述
        wbnrJhList: [
          this.$validUtils.required('维保内容')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改维保计划' : '新增维保计划'}`;
    },
    /* 计划类型 */
    jhlxList () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JHLX) {
        return Object.values(enums.IFF_JHLX); // 确保返回一个数组
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 计划类型变化处理
     * @return {*}
     * @param {*} params
     */
    handleJhlxChange (item) {
      this.handleJhmc(item);
      this.getWbnrList(item.id);
    },
    /**
     * @description: 客户变化处理
     * @return {*}
     */
    handleXmChange () {
      this.fd.wbnrJhList = [];
      this.jhnfList = [];
      this.handleQueryXmInfo();
    },

    /**
     * @description: 计划名称选中处理
     * @return {*}
     * @param {*} params 计划名称
     */
    handleJhmcChange (selectedIds) {
      console.log('计划名称选中处理', selectedIds);
      this.fd.wbjhSaveV2DetailVOS = this.wbjhSaveV2DetailVOS.filter(item => selectedIds.includes(item.id));
      console.log('选中已经计划名称', this.fd.wbjhSaveV2DetailVOS);
    },
    /**
     * @description: 获取“有效”客户列表
     * @return {*}
     */
    getYxxmList () {
      wbxmService.getYxxmList()
        .then(rsp => {
          this.xmList = rsp.data;
        })
        .catch(err => {
          console.error('获取合同有效项目列表信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取维保内容列表
     * @return {*}
     */
    getWbnrList (_zyzq) {
      this.loading = true;
      const requests = this.fd.jhlxDmList.map(id => wbxmService.getWbnrList(this.fd.xmId, id));
      Promise.all(requests)
        .then(responses => {
          // 合并所有响应数据并去重
          const allData = responses.flatMap(rsp => rsp.data);
          const uniqueData = Array.from(new Set(allData.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
          this.wbnrXmList = uniqueData;
        })
        .catch(err => {
          console.error('获取维保内容列表信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSave () {
      this.$refs.fd.validate(valid => {
        const flg = this.validateJhmc(this.fd);
        if (valid && flg) {
          this.addSave();
        }
      });
    },
    // 计划名称复选框校验
    validateJhmc (fd) {
      const jhlxDmList = fd.jhlxDmList;

      // 如果计划类型为空，则不校验
      if (!jhlxDmList || jhlxDmList.length === 0) {
        return false;
      }

      const hasWBYD = jhlxDmList.some(item => item === 'YD');
      const hasWBJD = jhlxDmList.some(item => item === 'JD');
      const hasWBBN = jhlxDmList.some(item => item === 'BN');
      const hasWBQN = jhlxDmList.some(item => item === 'QN');

      const list = fd.wbjhSaveV2DetailVOS;
      if (list.length === 0) {
        this.$alert('请选择计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }
      if (list.length > 12) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 去重判断，如果list中的item.jhlxDm包含'YD', 则list的长度不能超过12
      const hasYD = list.some(item => item.jhlxDm === 'YD');
      if (hasYD && list.length > 12) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 如果包含YD，则list中的item.jhlxDm为'YD'的个数不能超过12
      if (hasYD && list.filter(item => item.jhlxDm === 'YD').length > 12) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 去重判断，如果list中的item.jhlxDm不包含'YD'且包含'JD', 则list的长度不能超过4
      const hasJD = list.some(item => item.jhlxDm === 'JD');
      if (!hasYD && hasJD && list.length > 4) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 如果包含JD，则list中的item.jhlxDm为'JD'的个数不能超过4
      if (hasJD && list.filter(item => item.jhlxDm === 'JD').length > 4) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 去重判断，如果list中的item.jhlxDm不包含'YD'且不包含'JD'且包含'BN', 则list的长度不能超过2
      const hasBN = list.some(item => item.jhlxDm === 'BN');
      if (!hasYD && !hasJD && hasBN && list.length > 2) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 如果包含BN，则list中的item.jhlxDm为'BN'的个数不能超过2
      if (hasBN && list.filter(item => item.jhlxDm === 'BN').length > 2) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 去重判断，如果list中的item.jhlxDm不包含'YD'且不包含'JD'且不包含'BN'且包含'QN', 则list的长度不能超过1
      const hasQN = list.some(item => item.jhlxDm === 'QN');
      if (!hasYD && !hasJD && !hasBN && hasQN && list.length > 1) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      // 如果包含QN，则list中的item.jhlxDm为'QN'的个数不能超过1
      if (hasQN && list.filter(item => item.jhlxDm === 'QN').length > 1) {
        this.$alert('请选择去除重复的计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      if (hasWBYD && !hasYD) {
        this.$alert('当前未选中月度计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      if (hasWBJD && !hasJD) {
        this.$alert('当前未选中季度计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      if (hasWBBN && !hasBN) {
        this.$alert('当前未选中半年计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      if (hasWBQN && !hasQN) {
        this.$alert('当前未选中年度计划名称！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {}
        });
        return false;
      }

      return true;
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      wbjhService.saveV2(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 计划名称处理
     * @return {*}
     */
    handleJhmc () {
      console.log('计划名称处理');
      this.fd.wbjhSaveV2DetailVOS = [];
      if (!this.fd.jhnf || !this.fd.jhlxDmList.length) {
        this.wbjhSaveV2DetailVOS = [];
        return;
      }
      this.handleInitJhmc(this.fd.jhlxDmList);
    },
    /**
       * @description: 初始化计划名称
       * @return {*}
       */
    handleInitJhmc (list) {
      console.log('初始化计划名称', list);
      const _this = this;
      if (!list || list.length === 0) {
        _this.wbjhSaveV2DetailVOS = [];
        return;
      }
      const _year = _this.fd.jhnf;
      _this.wbjhSaveV2DetailVOS = [];
      const hasYD = list.includes('YD');
      const hasJD = list.includes('JD');
      const hasBN = list.includes('BN');
      const hasQN = list.includes('QN');

      // 遍历计划类型
      list.forEach(item => {
        if (item === 'YD') {
          var sjq = new Date(_this.htyxqQ);
          for (; sjq.getTime() <= _this.htyxqZ;) {
            if (sjq.getFullYear() + '' === '' + _year) {
              const _jhmc = _year + '年' + (sjq.getMonth() + 1) + '月维保';
              _this.wbjhSaveV2DetailVOS.push({
                id: _jhmc,
                jhmc: _jhmc,
                jhsjQ: new Date(sjq.getFullYear(), sjq.getMonth(), 1),
                jhsjZ: new Date(sjq.getFullYear(), sjq.getMonth() + 1, 0),
                jhlxDm: 'YD'
              });
            }
            sjq = new Date(sjq.getFullYear(), sjq.getMonth() + 1, 1);
          }
        } else if (item === 'JD') {
          const quarters = ['第一季度', '第二季度', '第三季度', '第四季度'];
          for (var i = 0; i < quarters.length; ++i) {
            let _jhmc = _year + '年' + quarters[i] + '维保';
            if (hasYD) {
              const month = (i + 1) * 3;
              _jhmc = _year + '年' + month + '月维保/' + _jhmc;
            }
            _this.wbjhSaveV2DetailVOS.push({
              id: _jhmc,
              jhmc: _jhmc,
              jhsjQ: new Date(_year, i * 3, 1),
              jhsjZ: new Date(_year, (i + 1) * 3, 0),
              jhlxDm: 'JD'
            });
          }
        } else if (item === 'BN') {
          const halfYears = ['上半年', '下半年'];
          const halfYearQuarters = ['第二季度', '第四季度'];
          for (var j = 0; j < halfYears.length; ++j) {
            let _jhmc = _year + '年' + halfYears[j] + '维保';
            if (hasYD) {
              const month = (j + 1) * 6;
              _jhmc = _year + '年' + month + '月维保/' + _jhmc;
            }
            if (hasJD) {
              _jhmc = _year + '年' + halfYearQuarters[j] + '维保/' + _jhmc;
            }
            _this.wbjhSaveV2DetailVOS.push({
              id: _jhmc,
              jhmc: _jhmc,
              jhsjQ: new Date(_year, j * 6, 1),
              jhsjZ: new Date(_year, (j + 1) * 6, 0),
              jhlxDm: 'BN'
            });
          }
        } else if (item === 'QN') {
          let _jhmc = _year + '年度维保';
          if (hasJD) {
            _jhmc = _year + '年第四季度维保/' + _jhmc;
          } else if (hasYD) {
            _jhmc = _year + '年12月维保/' + _jhmc;
          } else if (hasBN) {
            _jhmc = _year + '年下半年维保/' + _jhmc;
          }
          _this.wbjhSaveV2DetailVOS.push({
            id: _jhmc,
            jhmc: _jhmc,
            jhsjQ: new Date(_year, 0, 1),
            jhsjZ: new Date(_year, 12, 0),
            jhlxDm: 'QN'
          });
        }
      });

      // Special handling for combinations
      if (hasBN && hasJD) {
        _this.wbjhSaveV2DetailVOS = _this.wbjhSaveV2DetailVOS.filter(item => !item.jhmc.includes('上半年') && !item.jhmc.includes('下半年'));
        const halfYears = ['上半年', '下半年'];
        const halfYearQuarters = ['第二季度', '第四季度'];
        for (var j = 0; j < halfYears.length; ++j) {
          const _jhmc = _year + '年' + halfYearQuarters[j] + '维保/' + _year + '年' + halfYears[j] + '维保';
          _this.wbjhSaveV2DetailVOS.push({
            id: _jhmc,
            jhmc: _jhmc,
            jhsjQ: new Date(_year, j * 6, 1),
            jhsjZ: new Date(_year, (j + 1) * 6, 0),
            jhlxDm: 'BN'
          });
        }
      }

      if (hasJD && hasQN) {
        _this.wbjhSaveV2DetailVOS = _this.wbjhSaveV2DetailVOS.filter(item => !item.jhmc.includes('年度维保'));
        const _jhmc = _year + '年第四季度维保/' + _year + '年度维保';
        _this.wbjhSaveV2DetailVOS.push({
          id: _jhmc,
          jhmc: _jhmc,
          jhsjQ: new Date(_year, 9, 1),
          jhsjZ: new Date(_year, 12, 0),
          jhlxDm: 'QN'
        });
      }

      if (hasBN && hasQN) {
        _this.wbjhSaveV2DetailVOS = _this.wbjhSaveV2DetailVOS.filter(item => !item.jhmc.includes('年度维保'));
        const _jhmc = _year + '年下半年维保/' + _year + '年度维保';
        _this.wbjhSaveV2DetailVOS.push({
          id: _jhmc,
          jhmc: _jhmc,
          jhsjQ: new Date(_year, 6, 1),
          jhsjZ: new Date(_year, 12, 0),
          jhlxDm: 'QN'
        });
      }

      console.log('计划名称列表', _this.wbjhSaveV2DetailVOS);
    },
    /**
     * @description: 获取项目信息
     * @return {*}
     */
    handleQueryXmInfo () {
      if (!this.fd.xmId) {
        return;
      }
      return new Promise((resolve, reject) => {
        resolve(this.getWbxmInfo());
      });
    },
    async getWbxmInfo () {
      const _this = this;
      await wbjhService.getWbxmInfo(this.fd.xmId)
        .then(rsp => {
          _this.fd.xmId = rsp.data.xmId;
          _this.fd.xmmc = rsp.data.xmmc;
          _this.htyxqQ = rsp.data.htyxqQ;
          _this.htyxqZ = rsp.data.htyxqZ;
          var htyxqQY = new Date(_this.htyxqQ).getFullYear();
          var htyxqZY = new Date(_this.htyxqZ).getFullYear();

          for (; htyxqQY <= htyxqZY; htyxqQY++) {
            _this.jhnfList.push({ id: htyxqQY, text: htyxqQY });
          }
        })
        .catch(err => {
          console.error('获取维保项目详情信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  watch: {
    'fd.jhlxDmList' (newVal, oldVal) {
      // 监听 jhlxDmList 的变化，重新生成计划名称
      this.handleJhmc();
      // 如果有选中的维保周期且已选择项目，则获取维保内容
      if (newVal && newVal.length > 0 && this.fd.xmId) {
        this.getWbnrList();
      }
    }
  },
  created () {
    console.log('新增', this.editShow);
    if (this.$route.params.xmId) {
      this.fd.xmId = this.$route.params.xmId;
      this.loading = true;
      this.handleQueryXmInfo(); // 获取项目可取计划年份
    } else {
      this.loading = true;
      // 获取合同有效的项目列表
      this.getYxxmList();
    }
  }
};
</script>
